import { render } from "./loeffelComponent.vue?vue&type=template&id=9f075826&scoped=true"
import script from "./loeffelComponent.vue?vue&type=script&lang=js"
export * from "./loeffelComponent.vue?vue&type=script&lang=js"

import "./loeffelComponent.vue?vue&type=style&index=0&id=9f075826&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f075826"]])

export default __exports__